import { render, staticRenderFns } from "./MessageStatus.vue?vue&type=template&id=05881ef5&functional=true"
import script from "./MessageStatus.vue?vue&type=script&lang=js"
export * from "./MessageStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports